const carouselItems = [
  {
    id: 1,
    title: '2026暑期档·国产电影大爆发',
    desc: '多部国产大片集中上映，票房口碑双丰收，这个夏天不容错过的影院级体验。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20summer%20blockbuster%20movie%20collage%20with%20dramatic%20warm%20golden%20and%20red%20lighting%2C%20cinematic%20film%20poster%20composition%2C%20epic%20scale%2C%20vibrant%20colors%2C%20movie%20theater%20atmosphere&width=600&height=340&seq=carousel-01-90movies&orientation=landscape',
    tag: '专题',
  },
  {
    id: 2,
    title: '韩剧高分片单·治愈系精选',
    desc: '精选近三年豆瓣8分以上韩剧，从爱情到悬疑，每一部都值得二刷。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20cherry%20blossoms%20and%20soft%20pastel%20warm%20lighting%2C%20emotional%20atmosphere%2C%20cinematic%20composition%2C%20tender%20mood%2C%20spring%20aesthetic&width=600&height=340&seq=carousel-02-90movies&orientation=landscape',
    tag: '片单',
  },
  {
    id: 3,
    title: '悬疑片爱好者必看的十部神作',
    desc: '高能反转、烧脑剧情，每一部都让你猜到最后一秒，悬疑迷的狂欢盛宴。',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20dimly%20lit%20room%20with%20dramatic%20shadows%2C%20detective%20noir%20atmosphere%2C%20venetian%20blind%20light%20patterns%2C%20suspenseful%20cinematic%20aesthetic%2C%20warm%20amber%20and%20deep%20shadow%20contrast&width=600&height=340&seq=carousel-03-90movies&orientation=landscape',
    tag: '合集',
  },
  {
    id: 4,
    title: '纪录片·足不出户看世界',
    desc: 'BBC、NHK顶级纪录片大合集，自然、历史、科技，打开认知新世界。',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20snow%20capped%20mountains%20and%20aurora%20borealis%2C%20vast%20landscape%2C%20warm%20twilight%20sky%2C%20cinematic%20wide%20angle%2C%20breathtaking%20natural%20beauty&width=600&height=340&seq=carousel-04-90movies&orientation=landscape',
    tag: '纪录',
  },
  {
    id: 5,
    title: '热血动漫·燃到停不下来',
    desc: '从经典到新番，热血战斗、治愈日常，动漫迷的终极追番指南。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20style%20art%20with%20vibrant%20colors%20and%20action%20composition%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20red%20tones%2C%20Japanese%20animation%20aesthetic%2C%20energy%20burst%20visuals%2C%20cinematic%20feel&width=600&height=340&seq=carousel-05-90movies&orientation=landscape',
    tag: '动漫',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            专题聚焦
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[560px] mx-auto">
            精心策划的影视专题与片单合集，发现更多优质观影选择
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group relative bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-accent-200/50 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-2.5 left-2.5 px-2 py-0.5 text-[10px] font-medium text-accent-700 bg-accent-100 rounded whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3.5 flex-1 flex flex-col">
                <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}